/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Challenge_Phase_2_TitleInputs */

const en_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unleash Your Focus Power`)
};

const ar_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أطلق قوة تركيزك`)
};

const de_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entfesseln Sie Ihre Fokuskraft`)
};

const es_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libera tu poder de concentración`)
};

const fr_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libérez votre pouvoir de concentration`)
};

const it_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sblocca il tuo potere di concentrazione`)
};

const ja_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中力を解き放つ`)
};

const ko_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중력을 발휘하세요`)
};

const pt_br_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Liberte seu poder de foco`)
};

const ru_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Раскройте силу своей концентрации`)
};

const th_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ปลดปล่อยพลังการโฟกัสของคุณ`)
};

const tr_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İçindeki Odaklanma Gücünü Serbest Bırak`)
};

const zh_cn_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`释放你的专注力量`)
};

const zh_tw_starter_challenge_phase_2_title = /** @type {(inputs: Starter_Challenge_Phase_2_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`釋放你的專注力量`)
};

/**
* | output |
* | --- |
* | "Unleash Your Focus Power" |
*
* @param {Starter_Challenge_Phase_2_TitleInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_challenge_phase_2_title = /** @type {((inputs?: Starter_Challenge_Phase_2_TitleInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Challenge_Phase_2_TitleInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_challenge_phase_2_title(inputs)
	if (locale === "ar") return ar_starter_challenge_phase_2_title(inputs)
	if (locale === "de") return de_starter_challenge_phase_2_title(inputs)
	if (locale === "es") return es_starter_challenge_phase_2_title(inputs)
	if (locale === "fr") return fr_starter_challenge_phase_2_title(inputs)
	if (locale === "it") return it_starter_challenge_phase_2_title(inputs)
	if (locale === "ja") return ja_starter_challenge_phase_2_title(inputs)
	if (locale === "ko") return ko_starter_challenge_phase_2_title(inputs)
	if (locale === "pt_br") return pt_br_starter_challenge_phase_2_title(inputs)
	if (locale === "ru") return ru_starter_challenge_phase_2_title(inputs)
	if (locale === "th") return th_starter_challenge_phase_2_title(inputs)
	if (locale === "tr") return tr_starter_challenge_phase_2_title(inputs)
	if (locale === "zh_cn") return zh_cn_starter_challenge_phase_2_title(inputs)
	return zh_tw_starter_challenge_phase_2_title(inputs)
});